import React, { useEffect, } from "react";
import Footer from "../Common/Footer";
import Header from "../Common/Header";

function Terms() {

    
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
    <Header/>
    <section  className="policy">
    <div  className="container">
      <h3 >Terms and Conditions</h3>
      <div  className="content-box">
        <div >
          <p >
            Welcome to Smartuworld Your use of Smartuworld ("services" or "our services")
            is subject to these Terms. Compliance with these Terms
          </p>
          <p >
            <b >
              {" "}
              These Terms apply to you if you are a user of our services anywhere
              in the world .You must comply with these Terms in your use of our
              services and only use our services as permitted by applicable laws
              and regulations, wherever you may be when you use them. You must
              review these Terms and our policies and instructions to understand
              how you can and cannot use our services. If you do not agree to
              these Terms, you must not use our services.{" "}
            </b>
          </p>
          <p >Other terms in relation to these Terms</p>
          <p >
            If you are under the age of 13, you must not use our services. If you
            are between the ages of 13 and 18 (or the relevant age in your
            jurisdiction where you are considered a minor), your parent or
            guardian must agree to these Terms (both for themselves and on your
            behalf) before you can use our services.
          </p>
          <p >
            If you are using our services on behalf of a company, partnership,
            association, government or other organisation (your “
            <b >
              <em >Organisation</em>
            </b>
            ”), you warrant that you are authorised to do so and that you are
            authorised to bind your Organisation to these Terms and in such
            circumstances “you” will include your Organisation. We may translate
            these Terms into multiple languages, and in the event there is any
            difference between the English version and any other language version
            of these Terms, the English version will apply (to the extent
            permitted by applicable law).
          </p>
          <p >
            {" "}
            To the extent that any additional terms of service or policies are
            different from these Terms, the relevant additional terms of service
            or additional policies will apply, except that nothing in those
            additional terms of service or policies will (unless expressly
            indicated otherwise in those additional terms of service or policies)
            amend the following sections of these Terms (which will apply in the
            event there is any difference):
          </p>
          <ul >
            <li >
              “Changes to these Terms and our services”;
            </li>
            <li >
              “Our intellectual property rights and software”; and
            </li>
            <li >
              “Liability for our services and software”.
            </li>
          </ul>
          <p >
            However, to the extent that any country-specific terms differ from
            these Terms or any additional terms of service or policies, the
            relevant country-specific terms will apply, regardless of which
            section of these Terms is in question.
          </p>
          <p >
            <strong >
              CHANGES TO TERMS AND OUR SERVICES
            </strong>{" "}
            We may make changes to these Terms over time, so please come back and
            review them. In addition, as our services and user experience are
            constantly evolving, we may from time to time (and to the extent
            permitted by applicable law) add, change or remove features from our
            services (including in relation to whether a service is free of charge
            or not), or suspend or terminate a service altogether.{" "}
          </p>
          <p >
            <strong >
              Where we consider that any changes to these Terms or our services
              are reasonably material, we will notify you (via
              https://www.Smartuworld.com, direct communication to you, or other
              means), prior to the change becoming effective. By continuing to use
              our services after we make any changes to these Terms or our
              services, with or without notice from us, you are agreeing to be
              bound by these revised Terms.
            </strong>
            <b >YOUR ACCOUNT</b> You may need to create an
            account with us in order to access and use some of our services. Any
            account you open with us is personal to you and you are prohibited
            from gifting, lending, transferring or otherwise permitting any other
            person to access or use your account. Your account name, user ID and
            other identifiers you adopt within our services remains our property
            and we can disable, reclaim and reuse these once your account is
            terminated or deactivated for whatever reason by either you or us. You
            are responsible for: (i) safeguarding any passwords used to access
            your account and our services, and (ii) all use of our services under
            your account. You must promptly notify us at support@Smartuworld.com if
            you know or suspect that your password or account has been
            compromised.<em >Account deactivation</em> Our
            services may offer methods for deactivating your service-specific
            account – please refer to the relevant service for further guidance.{" "}
          </p>
          <p >
            <strong >PAYMENTS</strong> You may, from time to
            time, make payments to us as part of your use of our services
            (including for the provision of our services or provision of certain
            additional features within our services). You must comply with all
            such terms in relation to your payments to us.{" "}
          </p>
          <p >
            <strong >REFUND POLICY</strong> We do not offer
            any refunds for any payment made towards software subscription fees
            and software development fees.{" "}
          </p>
          <p >
            <strong >YOUR CONTENT</strong> When you submit,
            upload, transmit or display any data, information, media or other
            content in connection with your use of our services (“{" "}
            <b >
              <em >Your Content</em>
            </b>
            ”), you understand and agree that:{" "}
          </p>
          <ul >
            <li >
              you will continue to own and be responsible for Your Content;
            </li>
            <li >
              we will not sell Your Content to any third party;
            </li>
            <li >
              our use of Your Content will be subject to our
              <em > Smartuworld Privacy Policy</em>;
            </li>
            <li >
              you are giving us and our affiliate companiesthe right to use Your
              Content (with no fees or charges payable by us to you) solely for
              the purposes of providing, promoting, developing and trying to
              improve our services, including new services that we may provide in
              the future;
            </li>
            <li >
              in using Your Content for these purposes, we and our affiliate
              companies may copy, reproduce, host, store, process, adapt, modify,
              translate, perform, distribute and publish Your Content worldwide in
              all media and by all distribution methods, including those that are
              developed in the future, provided that they are incorporated into
              our services which you use; and
            </li>
            <li >
              we may share Your Content with third parties that we work with to
              help provide, promote, develop and improve our services, but these
              third parties (other than our affiliate companies) will not make any
              separate use of Your Content for their own purposes (i.e. for any
              purposes that are not related to our services).
            </li>
          </ul>
          <p >
            In addition, you agree that we and our affiliate companies (subject to
            these Terms, our{" "}
            <em > Smartuworld Privacy Policy</em> and applicable
            laws and regulations):
          </p>
          <ul >
            <li >
              are allowed to retain and continue to use Your Content after you
              stop using our services- for example, where you have shared Your
              Content with other users of our services; and
            </li>
            <li >
              may be required to retain or disclose Your Content in order to
              comply with applicable laws or regulations, or in order to comply
              with a court order, subpoena or other legal process, or we and our
              affiliate companies may disclose Your Content in response to a
              lawful request by a government authority, law enforcement agency or
              similar body (whether situated in your jurisdiction or elsewhere).
              You also agree that we may need to disclose Your Content in order to
              enforce these Terms, protect our rights, property or safety, or the
              rights, property or safety of our affiliate companies or other users
              of our services.
            </li>
          </ul>
          <p >
            {" "}
            You understand that even if you seek to delete Your Content from our
            services, it may as a technical and administrative matter take some
            time or not be possible to achieve this.
            <em >Responsibility for Your Content</em> You are
            solely responsible for Your Content and we recommend that you keep a
            back-up copy of it at all times. You must at all times ensure that:
            (i) you have the rights required to submit, transmit or display Your
            Content, and to grant us the rights as set out in these Terms; and
            (ii) Your Content (and our use of Your Content in accordance with
            these Terms) does not infringe or violate the rights of any person or
            otherwise contravene any applicable laws or regulations.{" "}
          </p>
          <p >
            <strong >
              THIRD PARTY CONTENT AND SERVICES
            </strong>{" "}
            We are not responsible for and we do not endorse, support or guarantee
            the lawfulness, accuracy or reliability of any content submitted to,
            transmitted or displayed by or linked by our services, including
            content provided by other users of our services or by our advertisers.
            You acknowledge and agree that by using our services you may be
            exposed to content which is inaccurate, misleading, defamatory,
            offensive or unlawful. Any reliance on or use of any content on or
            accessible from our services by you is at your own risk. Your use of
            our services does not give you any rights in or to any content you may
            access or obtain in connection with your use of our services. We also
            do not guarantee the quality, reliability or suitability of any third
            party services provided, made available or linked through our services
            and we will bear no responsibility for such third party services. If
            you access third party services through our services, you must comply
            with any terms and conditions applicable to those services. We may
            review (but make no commitment to review) content or third party
            services made available through our services to determine whether or
            not they comply with our policies, applicable laws and regulations or
            are otherwise objectionable. We may remove or refuse to make available
            or link to certain content or third party services if they infringe
            intellectual property rights, are obscene, defamatory or abusive,
            violate any rights or pose any risk to the security or performance of
            our services. There may be, from time to time, third party content and
            services on our services that are subject to further terms, including
            terms from the relevant third party that originally produced such
            content and services (for instance, the news agency that was
            responsible for writing a news article that then appears on our news
            service). In such cases, you agree to comply with any such further
            terms and conditions as notified to you. If you have any concerns
            regarding any content on or any other aspects of our services, please
            contact support@Smartuworld.com.{" "}
          </p>
          <p >
            <strong >
              ADVERTISING CONTENT ON OUR SERVICES
            </strong>{" "}
            Our services may include advertising or commercial content. You agree
            that we are allowed to integrate advertising or commercial content
            into our services and that (where reasonably practicable) we will
            identify paid services and communications. You also agree that, as
            explained in more detail in our{" "}
            <em > Smartuworld Privacy Policy</em>, we use
            targeted advertising to try to make advertising more relevant and
            valuable to you.{" "}
          </p>
          <p >
            <strong >DIRECT MARKETING</strong> We may use
            your information for the purpose of sending you advertising or direct
            marketing (whether by messaging within our services, by email or by
            other means) that offer or advertise products and services of ours
            and/or selected third parties. Such products and services include:{" "}
          </p>
          <ul >
            <li >
              products and services of ours (or our affiliate and subsidiary
              companies and joint venture partners), including services in
              relation to messaging, online media and advertising, interactive
              entertainment, social networking, e-commerce, news and information,
              payment, internet search, location and mapping, applications, data
              management, and other related software and services (“
              <b >Internet Services</b>”); and
            </li>
            <li >
              third party providers of Internet Services and products and services
              relating to dining, food and beverages, sports, music, film,
              television, live performances and other arts and entertainment,
              books, magazines and other publications, clothing and accessories,
              jewellery, cosmetics, personal health and hygiene, electronics,
              collectibles, housewares, appliances, home decoration and
              furnishings, pets, automobiles, hotels, transport and travel,
              banking, insurance and financial services, loyalty and reward
              programs and other products and services that we think may be
              relevant to you.
            </li>
          </ul>
          <p >
            {" "}
            If required by applicable laws, we will honour your request for us to
            not use your personal information for the direct marketing purposes
            noted above. If you wish to make such a request, please: (i) notify
            our Privacy Officer using the contact details as set out in the{" "}
            <em > Smartuworld Privacy Policy</em> ; (ii) follow
            the relevant instructions on our marketing messages; or (iii) if
            available, follow the instructions as set out in certain
            service-specific guidance (in relation to the relevant service).
            Please note that we will not share your personal information with
            advertisers unless you have given us your consent to do so. We do,
            however, share non-personal information with advertisers for the
            purposes of offering you advertising that is more relevant to you.{" "}
          </p>
          <p >
            <strong >
              OUR INTELLECTUAL PROPERTY RIGHTS
            </strong>{" "}
            All intellectual property rights in or to our services and software
            (including any future updates, upgrades and new versions) will
            continue to belong to us and our licensors. Except as expressly
            provided in these Terms, you have no right to use our intellectual
            property rights. In particular, you have no right to use our trade
            marks or product names (for example, “Tencent”, “Smartuworld” or “QQ”),
            logos, domain names or other distinctive brand features without our
            prior written consent. Any comments or suggestions you may provide
            regarding our services are entirely voluntary and we will be free to
            use these comments and suggestions at our discretion without any
            payment or other obligation to you. Where our services involve you
            downloading and using any software from us, we grant you a limited,
            personal, non-exclusive, non-sublicensable, non-transferrable,
            royalty-free and revocable licence to use the software in order to use
            our services in accordance with these Terms (including any specific
            technical requirements that relate to the software or its use on your
            particular device). Please note that these licence terms may be
            supplemented by terms and conditions applicable to the specific
            software. You may not copy, modify, reverse compile, reverse engineer
            or extract source codes from our software, except to the extent that
            we may not prohibit you from doing so under applicable laws or
            regulations or you have our prior written consent to do so. Where
            applicable laws or regulations entitle you to reverse compile or
            extract source codes from our software, you will first contact us to
            request the information you need. We may from time to time provide
            updates to our software. Such updates may occur automatically or
            manually. Please note that our services may not operate properly or at
            all if upgrades or new versions are not installed by you. We do not
            guarantee that we will make any updates available for any of our
            software, or that such updates will continue to support your device or
            system.{" "}
          </p>
          <p >
            <strong >THIRD PARTY SOFTWARE</strong> The “Third
            Party Content and Services” section above applies to any software
            supplied by third parties (including software, plug-ins, tools,
            codecs, data and content within such software) for use in connection
            with, or incorporated within, our services ("
            <b >Third Party Software</b>"), including your
            use of such Third Party Software. In addition to that section, please
            note that we are not responsible for and we do not endorse, support or
            guarantee the quality, reliability or suitability of any such Third
            Party Software. Any reliance on or use of such Third Party Software is
            at your own risk. You must comply with any additional terms and
            conditions applicable to any such Third Party Software. We will notify
            you of any such additional terms and conditions within our services,
            within an Appendix to these Terms and/or in another manner. We do not
            provide any technical support for any Third Party Software. Please
            contact the relevant supplying third party for such technical support.{" "}
          </p>
          <p >
            <strong >OPEN SOURCE SOFTWARE</strong> Further to
            the "Third Party Software" section above, our services may use
            software that is subject to “open source” licences (the “
            <b >Open Source Software</b>”). Where we use such
            Open Source Software, please note that:{" "}
          </p>
          <ul >
            <li >
              there may be provisions in the Open Source Software's licence that
              expressly override these Terms, in which case such provisions shall
              prevail to the extent of any conflict with these Terms; and
            </li>
            <li >
              we will credit the relevant Open Source Software (including
              notifying you of the relevant Open Source Software terms) within our
              services, within an{" "}
              <a  href="/terms-conditions">
                Appendix
              </a>{" "}
              to these Terms and/or in another manner.
            </li>
          </ul>
          <p >
            <strong >WARRANTY AND DISCLAIMER</strong> We
            warrant to you that we will provide our services using reasonable care
            and skill. APART FROM THIS WARRANTY, TO THE EXTENT PERMITTED BY
            APPLICABLE LAWS AND REGULATION, ALL OF OUR SERVICES AND SOFTWARE ARE
            PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS AND NEITHER US NOR ANY
            OF OUR AFFILIATE COMPANIES MAKE ANY REPRESENTATION OR WARRANTY OR
            GIVES ANY UNDERTAKING IN RELATION TO OUR SERVICES, OUR SOFTWARE OR ANY
            CONTENT SUBMITTED, TRANSMITTED OR DISPLAYED BY OUR SERVICES,
            INCLUDING: (I) ANY REPRESENTATION, WARRANTY OR UNDERTAKING THAT OUR
            SERVICES OR SOFTWARE WILL BE UNINTERRUPTED, SECURE OR ERROR-FREE OR
            FREE FROM VIRUSES; (II) THAT OUR SERVICES OR SOFTWARE WILL BE
            COMPATIBLE WITH YOUR DEVICE; OR (III) THAT OUR SERVICES OR SOFTWARE
            WILL BE OF MERCHANTABLE QUALITY, FIT FOR A PARTICULAR PURPOSE OR NOT
            INFRINGE THE INTELLECTUAL PROPERTY RIGHTS OF ANY PERSON. TO THE EXTENT
            PERMITTED BY APPLICABLE LAWS AND REGULATION, YOU WAIVE ANY AND ALL
            IMPLIED REPRESENTATIONS, WARRANTIES AND UNDERTAKINGS.{" "}
          </p>
          <p >
            <strong >
              LIABILITY FOR OUR SERVICES AND SOFTWARE
            </strong>{" "}
            TO THE EXTENT PERMITTED BY APPLICABLE LAWS AND REGULATIONS, THE TOTAL
            AGGREGATE LIABILITY OF US AND OUR AFFILIATE COMPANIES FOR ALL CLAIMS
            IN CONNECTION WITH THESE TERMS, THE GENERAL END USER LICENCE AGREEMENT
            OR OUR SERVICES OR SOFTWARE, ARISING OUT OF ANY CIRCUMSTANCES, WILL BE
            LIMITED TO THE GREATER OF THE FOLLOWING AMOUNTS: (I) THE AMOUNT THAT
            YOU HAVE PAID TO US FOR YOUR USE OF THE SPECIFIC SERVICE OR SOFTWARE
            TO WHICH THE CLAIM RELATES IN THE 6 MONTHS IMMEDIATELY PRECEDING THE
            DATE OF THE MOST RECENT CLAIM; AND (II) INR 10000. TO THE EXTENT
            PERMITTED BY APPLICABLE LAWS AND REGULATIONS, IN NO EVENT WILL WE OR
            ANY OF OUR AFFILIATE COMPANIES BE LIABLE IN CONNECTION WITH THESE
            TERMS, THE GENERAL END USER LICENCE AGREEMENT OR OUR SERVICES OR
            SOFTWARE FOR ANY DAMAGES CAUSED BY: (I) ANY NATURAL DISASTER SUCH AS
            FLOODS, EARTHQUAKES OR EPIDEMICS; (II) ANY SOCIAL EVENT SUCH AS WARS,
            RIOTS OR GOVERNMENT ACTIONS; (III) ANY COMPUTER VIRUS, TROJAN HORSE OR
            OTHER DAMAGE CAUSED BY MALWARE OR HACKERS; (IV) ANY MALFUNCTION OR
            FAILURE OF OUR OR YOUR SOFTWARE, SYSTEM, HARDWARE OR CONNECTIVITY; (V)
            IMPROPER OR UNAUTHORISED USE OF OUR SERVICES OR SOFTWARE; (VI) YOUR
            USE OF OUR SERVICES OR SOFTWARE IN BREACH OF THESE TERMS OR THE
            GENERAL END USER LICENCE AGREEMENT; OR (VII) ANY REASONS BEYOND OUR
            REASONABLE CONTROL OR PREDICTABILITY. NOR WILL WE, TO THE EXTENT
            PERMITTED BY APPLICABLE LAWS AND REGULATIONS, BE LIABLE UNDER ANY
            CIRCUMSTANCES FOR ANY INDIRECT, SPECIAL, CONSEQUENTIAL, EXEMPLARY OR
            PUNITIVE DAMAGES OR FOR ANY LOSS OF BUSINESS, REVENUES, PROFITS,
            GOODWILL, CONTENT OR DATA. Nothing in these Terms limits or excludes
            any of the following liabilities, except to the extent that such
            liabilities may be waived, limited or excluded under applicable laws
            and regulations:{" "}
          </p>
          <ul >
            <li >
              any liability for death or personal injury;
            </li>
            <li >
              any liability for gross negligence or wilful misconduct; or
            </li>
            <li >
              any other liability to the extent that such liability cannot be
              waived, limited or excluded under applicable laws and regulations.
            </li>
          </ul>
          <p >
            {" "}
            NOTWITHSTANDING ANY OTHER PROVISIONS OF THESE TERMS, NOTHING IN THESE
            TERMS LIMITS OR EXCLUDES ANY OF YOUR STATUTORY RIGHTS IN YOUR
            JURISDICTION (INCLUDING ANY RIGHTS UNDER APPLICABLE CONSUMER
            PROTECTION REGULATION), TO THE EXTENT THESE MAY NOT BE EXCLUDED OR
            WAIVED UNDER APPLICABLE LAWS AND REGULATIONS. YOU AGREE THAT YOU (AND
            YOUR ORGANISATION, IF YOU ARE USING OUR SERVICES OR SOFTWARE ON BEHALF
            OF SUCH ORGANISATION) INDEMNIFY US, OUR PARTNERS AND OUR AFFILIATE
            COMPANIES FROM AND AGAINST ANY CLAIM, SUIT, ACTION, DEMAND, DAMAGE,
            DEBT, LOSS, COST, EXPENSE (INCLUDING LITIGATION COSTS AND ATTORNEYS’
            FEES) AND LIABILITY ARISING FROM: (I) YOUR USE OF OUR SERVICES OR
            SOFTWARE; OR (II) YOUR BREACH OF THESE TERMS OR ANY TERMS OF THE
            GENERAL END USER LICENCE AGREEMENT. Please note that we are not
            responsible for any third party charges you incur (including any
            charges from your internet and telecommunication services providers)
            in relation to or arising from your use of our services or software.{" "}
          </p>
          <p >
            <strong >TERMINATION</strong> These Terms will
            apply to your use of our services until access to the relevant
            services is terminated by either you or us. We may suspend or
            terminate your access to your account or any or all of our services:
            (i) if we reasonably believe that you have breached these Terms; (ii)
            if your use of our services creates risk for us or for other users of
            our services, gives rise to a threat of potential third party claims
            against us or is potentially damaging to our reputation; (iii) if you
            fail to use our services for a prolonged period; or (iv) for any other
            reason. Where reasonably practicable, we will give you notice of any
            suspension or termination.
            <em >Retention and back-up of Your Content</em>{" "}
            Following termination of these Terms, we will only retain and use Your
            Content in accordance with these Terms, in particular the
            <em >Smartuworld Privacy Policy</em>. Where we
            suspend or terminate a service, or where your access to our services
            is terminated by you or us, we do not guarantee that we will be able
            to return any of Your Content back to you and we may permanently
            delete Your Content without notice to you at any time after
            termination. Please ensure that you regularly back up Your Content.{" "}
          </p>
          <p >
            <strong >GENERAL</strong> These Terms are the
            entire agreement between you and us in relation to our services. You
            agree that you will have no claim against us for any statement which
            is not explicitly set out in these Terms. The invalidity of any
            provision of these Terms (or parts of any provision) will not affect
            the validity or enforceability of any other provision (or the
            remaining parts of that provision). If a court holds that we cannot
            enforce any part of these Terms as drafted, we may replace those terms
            with similar terms to the extent enforceable under applicable law,
            without changing the remaining terms of these Terms. No delay in
            enforcing any provision of these Terms will be construed to be a
            waiver of any rights under that provision. Any rights and obligations
            under these Terms which by their nature should survive, including but
            not limited to any obligations in relation to the liability of, or
            indemnities (if any) given by, the respective parties, will remain in
            effect after termination or expiration of these Terms. No person other
            than you and us will have any right to enforce these Terms against any
            person, and you may not delegate, assign or transfer these Terms or
            any rights or obligations under these Terms, by operation of law or
            otherwise without our consent. We may freely assign, transfer or
            sub-contract these Terms or our rights and obligations under these
            Terms, in whole or in part, without your prior consent or notice. You
            acknowledge and agree that in no event will our partners or affiliate
            companies have any liability under these Terms.{" "}
          </p>
        </div>
      </div>
    </div>
  </section>
  <Footer/>
  </>
  );
}

export default Terms;
